import { Box, styled } from "@mui/material";
export const StyledDiv = styled("div")({});
export const FilledTextArea = styled("textarea")({
    width: "100%",
    height: "100%",
});
export const ScrollableFilledBox = styled(Box)({
    width: "100%",
    height: "100%",
    overflowY: "auto",
});
export const InlineDiv = styled("div")({
    display: "inline-block",
});
export const bgSx = {
    bgcolor: "background.default",
};
